module.exports = __webpack_public_path__ + "static/media/flight_icon.579e6061.svg";